import {React,useEffect} from 'react';
import { WalletMultiButton } from '@solana/wallet-adapter-react-ui';
import { Container, Paper, Typography, Box } from '@mui/material';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

const NotConnect = () => {
const {authSuccess} = useAuth();
const navigate = useNavigate();
    useEffect(()=>{
if (authSuccess){
navigate('/');
}
    },[authSuccess])
    
  return (
    <Container maxWidth="sm">
      <Paper 
        elevation={3} 
        sx={{ 
          padding: 4, 
          textAlign: 'center', 
          marginTop: 8,
          borderRadius: 2
        }}
      >
        <Typography variant="h4" gutterBottom>
          Wallet Not Connected
        </Typography>
        <Typography variant="body1" gutterBottom>
          Please connect your wallet to continue.
        </Typography>
        <Box mt={3}>
          <WalletMultiButton />
        </Box>
      </Paper>
    </Container>
  );
};

export default NotConnect;
